module.exports = __webpack_public_path__ + "img/certificate.74a8145b.svg";